<template>
  <div class="view text-sm p-4 border">
    <div class="bg-secondary-light px-4 py-2 border text-paragraph-light mb-4">
      Sie können aktuell keinen Artikel dieser Bestellung zurücksenden.
      Entweder sind die Artikel noch nicht verschickt oder Sie haben bereits eine Retoure angemeldet.
    </div>
    <MyAccountOrderEntryInfo :order="order" />
    <div>
      <MyAccountOrderEntryArticleList :order="order" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Order } from '~/composables/shoppingCartApi';

const props = defineProps({
  order: {
    type: Object as PropType<Order>,
    required: true
  }
});
</script>